<div class="progress loop" *ngIf="loading$ | async"></div>
<router-outlet></router-outlet>
